const getExpirationDate = (day: number) => {
  const expirationDate = new Date();
  return expirationDate.setDate(expirationDate.getDate() + 7);
};

export default getExpirationDate;
